import React from 'react';
import PinInput from 'react-pin-input';
import './PinEntry.css';

type PinEntryProps = PinInput['props'];

function PinEntry(props: PinEntryProps) {
  return <PinInput {...props} />;
}

export default PinEntry;
